import { FC } from 'react';
import { ExclamationIcon } from '../ExclamationIcon';
import { IconProps } from '../types';

const DEFAULT_COLOR = '#D97706';

export const FurtherInformationRequiredIcon: FC<IconProps> = ({ color = DEFAULT_COLOR }) => (
  <ExclamationIcon color={color} />
);
